/* eslint-disable */
<template>
<div width="90%">
  <h3 style="text-align:center">51Talk用户学情调研</h3>
  <div>
    亲爱的家长，恭喜您已经为孩子的未来迈出了重要的一小步，咱们班主任为了给孩子制定<strong style="color:orange">个性化的学习规划</strong>,需要提前了解宝贝的一些学习情况，需要您如实填写孩子的相关信息，您的数据我们会<strong>高度保密</strong>，感谢您对51alk的关注和支持!
  </div>
  <div class="breakline"></div>


  <div v-for="(ques, index) in questions" v-bind:key="index" class="flex-row">
    <div class="flex ques_header"><span class="ques_order">{{index+1}}</span></div>
    <div style="width: 100%">
      <question :question="ques" v-on:setAnswer="getAnswer" :id="ques.id"></question>
    </div>
  </div>

  <div style="text-align:center; margin-top: 10px; color:orange">
    <button @click="submit" class="feedback" :disabled="!isCompleteAnswer">提交</button>
  </div>
  <!-- <lessonDialog title="温馨提示" :content="content" :is-show="isShow" @confirm="confirm"></lessonDialog> -->
</div>
</template>

<script>
require('@/assets/css/common-flex.css')
require('@/assets/css/feedback.css')
import lessonDialog from '@/components/template/dialog/index.vue';
import Question from '@/components/template/question/Question'

export default {
  name: 'SS_Invest',
  components: {Question},
  data () {
    return {
      questions: [
        {
          id: 1,
          ques_type: 1,
          body: '孩子在学校开始学习英语的时间是? *',
          option:['幼儿园','一年级','三年级','还未学习']
        }, // slider
        {
          id: 2,
          ques_type: 1,
          body: '孩子在校期间英语平均考试成绩？ *',
          option: ['没考试过', '优秀', '良好', '中等', '中下', '不及格']
        },
        {
          id: 3,
          ques_type: 2,
          body: '学校英语考试中孩子的失分点或者通过其他方式了解到的孩子英语薄弱处?（多选/最多3项) *',
          option: ['不了解','自然拼读','词汇记忆','发音','英文写作','听力理解','句子理解','语法知识','阅读理解(技巧)','流利度']
        },
        {
          id: 4,
          ques_type: 2,
          body: '家长迫切需要了解的主题有?（多选/最多5项) *',
          option: ['PET/KET等考试','小学语法','写作提升','新概念','中考语法','自然拼读技巧','学校知识同步辅导','英语学习方法','育儿方法','字母启蒙','儿童童谣','绘本阅读','旅游英语','音标入门','词汇强化','演讲技能','百科知识','阅读能力','出国']
        },
        {
          id: 5,
          ques_type: 1,
          body: '为了跟喜欢的老师上课，是否愿意为了协调自己的时间? *',
          option: ['是','否']
        }
      ],
      answers: {},
      answers_user: {},
      // isShow: false,
      content: '感谢您的耐心填写！',
      isCompleteAnswer: false
    }
  },
  methods: {
    getAnswer: function (qid, ans) {
      this.answers[qid] = ans
      this.checkAnswer()  //无需检验是否完成即可提交
    },
    submit: function () {
      // console.table(this.answers)
      var uid = this.$route.query.uid
      this.answers_user['uid'] = uid
      this.answers_user['answer'] =  this.answers
      console.log(this.answers_user)
      $.ajax({
          type: "post",
          url: "http://10.0.2.70:8124/api/cms_application/ft_question_user_answer",  //提交到70测试的api
          dataType: "json",//返回的数据类型格式 JSON.stringify(
          data: JSON.stringify(this.answers_user),  //
          success: function(ret){  //成功的时候返回的是数据，错误的时候数据为空
            if (ret.error_code === 0){  //修改成功 msg.success
              console.log('数据准确')
            }else {  //修改失败
              console.log(ret)
              console.log('数据出错了')
            }
          }
      })
      alert('感谢您的耐心填写！');
      // history.back(); //返回到上一页
    },
    checkAnswer: function () {
      for (let i = 0; i < this.questions.length; i++) {
        let qid = this.questions[i].id
        let ans = this.answers[qid]
        //需用户答完提交，如若无需答完，答某一些部分就可以提交，这部分if可注释
        // if (ans === undefined || ans === null || ans === '' || ans.length === 0) {
        //   console.log('Question ' + qid + ' is not answered!')
        //   this.isCompleteAnswer = false
        //   return
        // }
      }
      this.isCompleteAnswer = true
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.ques_order{
  height:20px;
  line-height:20px;
  display:block; color:#FFF;
  text-align:center;
  font-size:12px;
}
</style>



// WEBPACK FOOTER //
// src/components/SS_Invest.vue